import { render, staticRenderFns } from "./QuoteTemplateTags.vue?vue&type=template&id=36acc152&scoped=true"
import script from "./QuoteTemplateTags.vue?vue&type=script&lang=js"
export * from "./QuoteTemplateTags.vue?vue&type=script&lang=js"
import style0 from "./QuoteTemplateTags.vue?vue&type=style&index=0&id=36acc152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36acc152",
  null
  
)

export default component.exports